import * as yup from 'yup';
import { queryClient } from '@providers/QueryClient';
import API from '@userAuth/Api';

const getPasswordPolicy = () =>
  queryClient
    .fetchQuery({
      queryKey: ['auth-password-policy'],
      queryFn: API.getPasswordPolicy,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000
    })
    .then(res => res?.data?.data)
    .catch(() => null);

// yup.string().password() => backend password policy; if it can't be loaded the server stays the only judge
yup.addMethod(yup.string, 'password', function () {
  return this.test('password', '', async function (value) {
    if (!value) return true;
    const policy = await getPasswordPolicy();
    if (!policy?.regex) return true;
    return new RegExp(policy.regex).test(value) || this.createError({ message: policy.description });
  });
});
